module.exports = __webpack_public_path__ + "static/media/MentorFilipa.e7447a24.png";